import { render, staticRenderFns } from "./PracticeSumupDetailTab.vue?vue&type=template&id=3d9b8829&scoped=true&"
import script from "./PracticeSumupDetailTab.vue?vue&type=script&lang=ts&"
export * from "./PracticeSumupDetailTab.vue?vue&type=script&lang=ts&"
import style0 from "./PracticeSumupDetailTab.vue?vue&type=style&index=0&id=3d9b8829&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9b8829",
  null
  
)

export default component.exports